import React, { useEffect, useState } from "react";
import { get, put } from "../../services/Services";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaSave, FaTimesCircle } from "react-icons/fa";

function SchoolEdit({ schoolId, onClose, updateSchools }) {
  const [school, setSchool] = useState(null);
  const [provinces, setProvinces] = useState([]);
  const [cities, setCities] = useState([]);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  // Cargar datos iniciales
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [schoolRes, provincesRes, usersRes] = await Promise.all([
          get(`/api/academy/schools/${schoolId}`),
          get(`/api/core/provinces?page=0&size=5000`),
          get(`/api/core/users?page=0&size=5000`)
        ]);

        setSchool({
          ...schoolRes.data,
          province: schoolRes.data.city?.province?.id || "",
          city: schoolRes.data.city?.id?.toString() || "",
          user: schoolRes.data.user?.id?.toString() || ""
        });

        setProvinces(provincesRes.data.content);
        setUsers(usersRes.data.content);

        if (schoolRes.data.city?.province?.id) {
          const citiesRes = await get(`/api/core/provinces/${schoolRes.data.city.province.id}/cities?page=0&size=5000`);
          setCities(citiesRes.data.content);
        }
      } catch (err) {
        console.error("Error al cargar datos:", err);
        alert("Error al cargar la información de la escuela.");
      }
    };

    fetchData();
  }, [schoolId]);

  // Manejar cambios de formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSchool((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "province" ? { city: "" } : {}) // resetear ciudad si cambia provincia
    }));
  };

  useEffect(() => {
    const loadCities = async () => {
      if (school?.province) {
        try {
          const citiesRes = await get(`/api/core/provinces/${school.province}/cities?page=0&size=5000`);
          setCities(citiesRes.data.content);
        } catch (err) {
          console.error("Error al cargar ciudades:", err);
        }
      }
    };
    loadCities();
  }, [school?.province]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const selectedCity = cities.find((c) => c.id.toString() === school.city);
      const selectedUser = users.find((u) => u.id.toString() === school.user);

      if (!selectedCity || !selectedUser) {
        alert("Debe seleccionar una ciudad y un usuario válidos.");
        return;
      }

      const payload = {
        name: school.name,
        address: school.address,
        phone: school.phone,
        mail: school.mail,
        status: school.status,
        city: { id: selectedCity.id },
        user: { id: selectedUser.id }
      };

      await put(`/api/academy/schools/${schoolId}`, payload);

      updateSchools?.();
      onClose();
    } catch (err) {
      console.error("Error al actualizar escuela:", err);
      alert("Error al actualizar la escuela.");
    } finally {
      setLoading(false);
    }
  };

  if (!school) return <p className="text-center mt-4">Cargando datos de la escuela...</p>;

  return (
    <div className="container mt-4">
      <div className="card shadow-lg p-4 w-100" style={{ maxWidth: "600px", margin: "auto" }}>
        <div className="card-header bg-warning text-white text-center">
          <h5 className="mb-0">Editar Escuela</h5>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="form-floating mb-3">
              <input type="text" id="name" name="name" value={school.name} onChange={handleChange} className="form-control" required />
              <label htmlFor="name">Nombre de la Escuela</label>
            </div>

            <div className="form-floating mb-3">
              <input type="text" id="address" name="address" value={school.address} onChange={handleChange} className="form-control" required />
              <label htmlFor="address">Dirección</label>
            </div>

            <div className="form-floating mb-3">
              <input type="text" id="phone" name="phone" value={school.phone} onChange={handleChange} className="form-control" required />
              <label htmlFor="phone">Teléfono</label>
            </div>

            <div className="form-floating mb-3">
              <input type="email" id="mail" name="mail" value={school.mail} onChange={handleChange} className="form-control" required />
              <label htmlFor="mail">Correo Electrónico</label>
            </div>

            <div className="mb-3">
              <label className="form-label">Provincia:</label>
              <select name="province" value={school.province} onChange={handleChange} className="form-select" required>
                <option value="">Seleccionar provincia</option>
                {provinces.map((province) => (
                  <option key={province.id} value={province.id}>{province.name}</option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Ciudad:</label>
              <select name="city" value={school.city} onChange={handleChange} className="form-select" required>
                <option value="">Seleccionar ciudad</option>
                {cities.map((city) => (
                  <option key={city.id} value={city.id}>{city.name}</option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Usuario:</label>
              <select name="user" value={school.user} onChange={handleChange} className="form-select" required>
                <option value="">Seleccionar usuario</option>
                {users.map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.userData?.name} {user.userData?.lastname}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-check form-switch mb-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="status"
                checked={school.status}
                onChange={() => setSchool((prev) => ({ ...prev, status: !prev.status }))}
              />
              <label className="form-check-label" htmlFor="status">Activo</label>
            </div>

            <div className="d-flex gap-2">
              <button type="submit" disabled={loading} className="btn btn-warning w-50 text-white">
                {loading ? "Guardando..." : "Guardar Cambios"} <FaSave className="ms-2" />
              </button>
              <button type="button" className="btn btn-outline-secondary w-50" onClick={onClose}>
                Cancelar <FaTimesCircle className="ms-2" />
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SchoolEdit;
